import { request } from 'umi';
import env, { isInWechat } from '@/utils/env';
import logStorage from './logStorage';

// 埋点上传请求
export default function logUpload(data: Record<string, any>) {
  const url = `${env.BLACKPEARL_HOST}/interfaces/analytic`;
  const { globalInfo } = logStorage;
  return request(url, {
    method: 'post',
    data: {
      from: isInWechat ? 'mp_h5' : 'h5',
      business: 'nova',
      env: env.ENV, // 环境
      ...globalInfo,
      ...(data || {}),
    },
    skipErrorHandler: true,
  }).catch(() => {
    // do nothing
  });
}
